import { IAjaxMetrics } from '../http/iajax_metrics';
/* istanbul ignore file */
export class MetricsHelper {

    static captureMetrics(requestEndTime: number, requestStartTime: number, url: string, type: string,
                          clientClassName: string, clientMethodName: string = '', uuid: string, status: string): void {
        const metricsObj: any = {
            type, url, clientClassName, clientMethodName, status,
            Noodle: uuid, api:'ClientAPIMetrics',
            benchmark: ((requestEndTime - requestStartTime) / 1000)
        }; // Added metric_hash as a local variable to add each call to metric_ary to log Client side metrics
        this.metricsArr.push(metricsObj);
        (window as any).photoOrg = (window as any).photoOrg || {}; 
        //to make metricsArr accessible in photoOrg scope   
        (window as any).photoOrg.metricsArr = this.metricsArr;
    }

    private static metricsArr: any[] = [];
}